import React from 'react';
import { useSelector } from 'react-redux';

import { getAreaFieldImagePath } from 'FRONTEND/utils/routes';

const AreaField = ({
  editable,
  fieldId,
  choices,
  values,
  column,
  row,
  width,
  height,
  photo,
  verticalOffset,
}) => {
  const locale = useSelector((state) => state.user.locale);

  const onAreaClick = (event) => {
    // Select the full area, not just the text if the user clicked on it. :)
    const area = event.target.classList.contains('areaField-part') ? event.target : event.target.parentNode;
    const text = area.querySelector('span');
    const input = area.querySelector('input');

    // Select the area if it wasn't selected and deselect it if it was.
    if (area.classList.contains('areaField-part-selected')) {
      area.classList.remove('areaField-part-selected');
      text.classList.add('hidden');
      // Removing the name from an input prevents it from being sent.
      input.name = null;
    } else {
      area.classList.add('areaField-part-selected');
      text.classList.remove('hidden');
      input.name = fieldId;
    }
  };

  const renderAreas = () => {
    const areas = [];

    for (let i = 0; i < (row * column); i++) {
      let value, label;
      if (Array.isArray(choices)) {
        value = choices[i];
        label = choices[i];
      } else {
        value = Object.keys(choices)[i];
        label = choices[value][locale];
      }

      const style = {
        width: `${width / column}px`,
        height: `${(height - verticalOffset) / row}px`,
      };

      const selected = values && values.includes(value);
      let classList = 'areaField-part';
      if (editable) {
        classList += ' areaField-part-clickable';
      }
      if (values && values.includes(value)) {
        classList += ' areaField-part-selected';
      }

      areas.push(
        <div
          style={style}
          className={classList}
          key={value}
          onClick={editable ? onAreaClick : null}
        >
          <span className={`areaField-label${label?.length > 7 ? ' areaField-labelFit' : ''}${selected ? '' : ' hidden'}`}>{label}</span>
          {editable && <input name={selected ? fieldId : null} value={value} type='hidden' />}
        </div>);
    }

    return areas;
  };

  return (
    <div className='areaField'>
      <div
        style={{
          paddingTop: `${verticalOffset}px`,
          width: `${width}px`,
          height: `${height}px`,
          backgroundImage: photo ? `url('${getAreaFieldImagePath(photo)}')` : null,
        }}
        className='areaField-imgContainer'
      >
        {renderAreas()}
      </div>
    </div>
  );
};

export default AreaField;
